import { makeContextModule } from '@cian/react-utils';

var _makeContextModule = makeContextModule({
  contextName: 'ContactActionsContext',
  defaultValue: {
    mobileButtonBackground: 'gray6_100'
  }
}),
    useContactActionsContext = _makeContextModule.useContext,
    ContactActionsContext = _makeContextModule.Context;

export { useContactActionsContext, ContactActionsContext };